import { CircularProgress } from "@mui/material";
import React from "react";

const ButtonLoader = ({ color = "var(--secondary-color)", size = 24 }) => {
  return <CircularProgress size={size} sx={{ color }} />;
};

export default ButtonLoader;
